function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 97",
  transform: "translate(-485 -6487)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 105",
  cx: 35,
  cy: 35,
  r: 35,
  transform: "translate(485 6487)",
  fill: "#f39c91"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-star",
  d: "M517.982 6505.251l-4.591 9.309-10.273 1.5a2.251 2.251 0 00-1.245 3.839l7.432 7.24-1.755 10.23a2.249 2.249 0 003.262 2.37l9.19-4.83 9.19 4.83a2.25 2.25 0 003.258-2.37l-1.755-10.23 7.432-7.24a2.251 2.251 0 00-1.245-3.839l-10.273-1.5-4.591-9.309a2.252 2.252 0 00-4.036 0z",
  fill: "#f9cec8"
}));
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70"
  }, props), _ref);
};
export default SvgStar;